import { render, staticRenderFns } from "./DigiViewAssessment.vue?vue&type=template&id=6a0d352a&"
import script from "./DigiViewAssessment.vue?vue&type=script&lang=js&"
export * from "./DigiViewAssessment.vue?vue&type=script&lang=js&"
import style0 from "./DigiViewAssessment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports